import { cn } from '@/utils/style'

interface UpdateToggleProps {
  value: boolean
  onChange: (value: boolean) => void
  className?: string
  type: 'autoRenewal' | 'expirationBehavior'
}

export function UpdateToggle({ value, onChange, className, type }: UpdateToggleProps) {
  const handleClick = () => {
    const next = !value
    onChange(next)
  }

  const label =
    type === 'autoRenewal' ? (value ? 'ON' : 'OFF') : value ? 'pay-as-you-go' : 'Release Instance'

  return (
    <button
      type="button"
      role="switch"
      aria-checked={value}
      onClick={handleClick}
      className={cn(
        'relative inline-flex items-center justify-center',
        'rounded-full px-2 py-[2px] text-[10px] font-semibold',
        'transition-colors',
        type === 'autoRenewal' ? 'w-[70px] h-6' : 'w-[150px] h-6',
        value ? 'bg-[#246BFF] text-white' : 'bg-gray-300 text-gray-700',
        className,
      )}
    >
      <span className="z-10 truncate text-xs">{label}</span>

      <span
        className={cn(
          'absolute top-1 h-4 w-4 rounded-full bg-white shadow',
          'transition-all duration-200',
          value ? 'right-1' : 'left-1',
        )}
      />
    </button>
  )
}
